<template>
  <b-container class="content">
    <h1>{{ $t('wifi.select') }}</h1>
    <b-spinner v-if="isUpdating" />
    <b-list-group class="mb-2">
      <b-list-group-item
        href="#"
        v-for="wifi in networks"
        v-bind:key="wifi.id"
        v-on:click="$emit('select_wifi', wifi)"
        :disabled="!wifi.supported"
      >
        <div class="d-flex w-100 justify-content-between align-middle">

          <b-progress
            class="m-2"
            variant="secondary"
            :value="wifi.signal_strength"
            :max="100"
            height="12px"
            style="min-width: 45px;"
            :style="wifi.supported ? '' : 'opacity: 0.5;'"
            show-progress>
          </b-progress>
          <!-- <b-icon-wifi class="m-1"></b-icon-wifi> -->
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-2">{{ wifi.ssid }}</h5>
            <div v-if="wifi.encryption === 'off'">
              <b-icon-unlock class="mt-1"></b-icon-unlock>
            </div>
            <div v-else>
              <b-icon-lock class="mt-1"></b-icon-lock>
              <small class="m-1">{{ wifi.encryption }}</small>
              <small class="m-1">{{ wifi.authentication_suites }}</small>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
    <div v-if="!isUpdating">
      <b-button variant="primary" v-on:click="update()">{{ $t('wifi.rescan') }}</b-button>
      <p>
        <a href="#" v-on:click="$emit('manual_wifi_configuration')">{{ $t('configureWifiManuallyLink') }}</a>
      </p>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SetupSelectWifi',
  props: ['mac'],
  data() {
    return {
      isUpdating: true,
      networks: [],
      selected: {
        'ssid': 'a',
        'encrycption': 'b'
      }
    }
  },
  created () {
    this.scanWifis();
  },
  methods: {
    update() {
      this.isUpdating = true;
      this.networks = [];
      this.scanWifis();
    },
    scanWifis() {
      this.isUpdating = true;
      axios
        .get('http://10.3.141.1:6762/api/v1/networks')
        .then(response => {
          this.isUpdating = false;
          if (response.status == 200) {
            this.networks = response.data.networks;
          }
        });
    }
  }
}
</script>

<style scoped>
.list-group{
  max-height: calc(100% - 240px);
  overflow-y: auto;
}
</style>
